import { Alert, Snackbar } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeGlobalMsgAlerts, selectGlobalMsgAlert } from "./globalMsgAlertsSlice";

function GlobalMsgAlert() {

    const alertProperties = useAppSelector(selectGlobalMsgAlert);
    const dispatch = useAppDispatch();
    const handlerCloseMsgAlert=()=>{
        dispatch(closeGlobalMsgAlerts({}));
    }

  return (
    <Snackbar
    open={alertProperties.isAlert}
    autoHideDuration={alertProperties.duration}
    onClose={handlerCloseMsgAlert}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
  >
    <Alert
      onClose={handlerCloseMsgAlert}
      severity={alertProperties.color}
      variant="filled"
      sx={{ width: "100%" }}
    >
      {alertProperties.msg}
    </Alert>
  </Snackbar>
  );
}

export default GlobalMsgAlert;
